import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class InvoiceApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="invoiceApply">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">关于发票申请</div>
                    <div className="first">
                        <div>1、电子发票免费开具，纸质发票收取10元邮寄费用。特殊要求请在发票申请备注内填写说明。</div>
                        <div>2、三个月以内的订单可以开具发票，超出时间不允开具；</div>
                        <div>3、行程结束后才可申请开具发票；</div>
                        <div> 4、电子发票在一个工作日内开具，纸质发票在3个工作日内开具并寄出。</div>
                        <div> 5、开票信息填写错误重开规则：</div>
                        <div className="textIndent">（1）纸质发票：如果纸质发票在当月内开具错误，请在当月内联系客服需要把开错的纸质发票邮寄回我公司，我公司收到后方可重开纸质发票寄回，并且来回运费需要自行承担。如果发票的开票时间已经跨月，则需要收取订单金额10%手续费并承担来回运费；</div>
                        <div className="textIndent">（2）电子发票：如果电子发票在当月内开具错误，请在当月内联系客服，可以重开，但开错的电子发票需作废。如果发票的开票时间已经跨月，则需要收取订单金额10%手续费。</div>
                        <div className="textIndent">（3）开票错误超过3个月的公司将不再重开；</div>
                        <div className="textIndent">（4）重开发票工作人员会在1-3个工作日与你联系，不接受任何急件处理。为了给你带来不必要的麻烦，请开票务必仔细检查你的开票信息及快递信息。</div>
                       
                        
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/InvoiceApply/index.js